/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { JofiCompany } from '../models/jofi-company';
import { JofiUser } from '../models/jofi-user';

@Injectable({
  providedIn: 'root',
})
export class JofiContentDeliveryCompaniesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation companiesDeliveryControllerFindAll
   */
  static readonly CompaniesDeliveryControllerFindAllPath = '/v1/content-delivery/companies';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `companiesDeliveryControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  companiesDeliveryControllerFindAll$Response(params?: {

    /**
     * This request requires a valid API key.
     */
    'x-api-key'?: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<JofiCompany>>> {

    const rb = new RequestBuilder(this.rootUrl, JofiContentDeliveryCompaniesService.CompaniesDeliveryControllerFindAllPath, 'get');
    if (params) {
      rb.header('x-api-key', params['x-api-key'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<JofiCompany>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `companiesDeliveryControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  companiesDeliveryControllerFindAll(params?: {

    /**
     * This request requires a valid API key.
     */
    'x-api-key'?: string;
    context?: HttpContext
  }
): Observable<Array<JofiCompany>> {

    return this.companiesDeliveryControllerFindAll$Response(params).pipe(
      map((r: StrictHttpResponse<Array<JofiCompany>>) => r.body as Array<JofiCompany>)
    );
  }

  /**
   * Path part for operation companiesDeliveryControllerFindById
   */
  static readonly CompaniesDeliveryControllerFindByIdPath = '/v1/content-delivery/companies/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `companiesDeliveryControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  companiesDeliveryControllerFindById$Response(params: {
    id: string;

    /**
     * This request requires a valid API key.
     */
    'x-api-key'?: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<JofiCompany>> {

    const rb = new RequestBuilder(this.rootUrl, JofiContentDeliveryCompaniesService.CompaniesDeliveryControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.header('x-api-key', params['x-api-key'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JofiCompany>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `companiesDeliveryControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  companiesDeliveryControllerFindById(params: {
    id: string;

    /**
     * This request requires a valid API key.
     */
    'x-api-key'?: string;
    context?: HttpContext
  }
): Observable<JofiCompany> {

    return this.companiesDeliveryControllerFindById$Response(params).pipe(
      map((r: StrictHttpResponse<JofiCompany>) => r.body as JofiCompany)
    );
  }

  /**
   * Path part for operation companiesDeliveryControllerFindMembersByCompanyId
   */
  static readonly CompaniesDeliveryControllerFindMembersByCompanyIdPath = '/v1/content-delivery/companies/{id}/members';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `companiesDeliveryControllerFindMembersByCompanyId()` instead.
   *
   * This method doesn't expect any request body.
   */
  companiesDeliveryControllerFindMembersByCompanyId$Response(params: {
    id: string;

    /**
     * This request requires a valid API key.
     */
    'x-api-key'?: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<JofiUser>>> {

    const rb = new RequestBuilder(this.rootUrl, JofiContentDeliveryCompaniesService.CompaniesDeliveryControllerFindMembersByCompanyIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.header('x-api-key', params['x-api-key'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<JofiUser>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `companiesDeliveryControllerFindMembersByCompanyId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  companiesDeliveryControllerFindMembersByCompanyId(params: {
    id: string;

    /**
     * This request requires a valid API key.
     */
    'x-api-key'?: string;
    context?: HttpContext
  }
): Observable<Array<JofiUser>> {

    return this.companiesDeliveryControllerFindMembersByCompanyId$Response(params).pipe(
      map((r: StrictHttpResponse<Array<JofiUser>>) => r.body as Array<JofiUser>)
    );
  }

}
